import { render, staticRenderFns } from "./gak-chuncheon.kr.vue?vue&type=template&id=b27288c8&"
import script from "./gak-chuncheon.kr.vue?vue&type=script&lang=js&"
export * from "./gak-chuncheon.kr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports